import React, { FunctionComponent, useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend,  Label } from 'recharts';
import moment from 'moment';
import '../../stations/Station.scss';
import { useStoreContext } from '../../../../../store/context';
import { CustomizedAxisTick } from '../chartsPopUpConstants';
import { ONEDAY, getMaxFromSelectedFields, getMinFromSelectedFields } from 'src/store/common';

type DailySRProps = {
    all_dates: any[]
}

const CustomTooltip:FunctionComponent = (props:any) => {
const {active, label,payload}=props;
if (active && payload && payload.length) {
  return (
    <div id="custom-tooltip" className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', display:'block', height: '3.25rem'}}>
      <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
      {moment(label).format("MMM DD, YYYY")}
      </span>
      <svg width="50" height="11" style={{display: 'block', paddingTop: '0.5px'}}>
        <rect width="5" height="5" style={{fill:'green'}}/>
        <text
          fontSize=".75rem"
          height="5"
          x={10}
          y={10}
        >
        {`${payload[0].value}`}
      </text>
      </svg>
    </div>
  );
}
return null;
};
export const SRDailyChart: React.FC<DailySRProps> = ({all_dates}) => {
  const [xTicks, setXTicks] = useState<number[]>([]);
  const [state] = useStoreContext();

  useEffect(()=>{
    if(all_dates.length>1){
      let ticks:number[]=[];

      if(ticks.length<1){
        let i = moment(all_dates[0].date).format('MMM DD');
        ticks.push(all_dates[0].date)
        let j=0;
        while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
          j=j+1;
          ticks.push(all_dates[0].date + j*ONEDAY)
          i = moment(all_dates[0].date + j*ONEDAY).format('MMM DD')
        }
        setXTicks(ticks)
      }
  
    }
  },[all_dates]);   
  
  return(
    <>
    {all_dates.length>1 &&(
        <LineChart
          width={375}
          height={140}
          data={all_dates}
          margin={{
            top: (10),
            right: 10,
            left: 5,
            bottom: 10,
          }}
        >
          <XAxis dataKey="date" interval={0} type="number" tick={<CustomizedAxisTick />} domain={[all_dates.at(-1).date, all_dates[0].date]} ticks={xTicks}/>          
          <YAxis yAxisId="left" orientation="left" 
            domain={[getMinFromSelectedFields(all_dates, ['srF', 'srObs'], 5), getMaxFromSelectedFields(all_dates, ['srF', 'srObs'])]}
            style={{fontSize: '0.7rem',fontFamily: 'serif'}} 
            axisLine={false}>
          <Label
            value={state.chartTable.value ==='Daily_Precip'?'Precipitation':'Solar Radiation'}
            position="insideLeft"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle' }}
          />
          </YAxis>
          <Tooltip content={<CustomTooltip />} position={{ y: -5 }} />
          <Legend wrapperStyle={{fontSize:'11px', top:'130px'}} iconType="plainline" iconSize={10}/>
          <Line name={state.chartTable.value ==='Daily_Precip'?'Precipitation':'Solar Radiation'} type="monotone" yAxisId ="left" dataKey="valObs" stroke="green" dot={ false} strokeWidth={2}/>
          <Line name={state.chartTable.value ==='Daily_Precip'?'Precipitation':'Solar Radiation'} type="monotone" yAxisId = "left" dataKey="valF" stroke="green" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
        </LineChart>
    )}
    </>

  );
}